// extracted by mini-css-extract-plugin
export var isPc = "utils-module--is-pc--a7afb";
export var isSp = "utils-module--is-sp--3c0d2";
export var onlyEn = "utils-module--only-en--20027";